import { ITCFVendor } from "types/tcf";
import type { ITCFConsent } from "../TCFConsentProvider/types";

const isTCFVendorLegitimateInterestAccepted = (
  vendor: ITCFVendor,
  consent: ITCFConsent,
): boolean => {
  return !!consent.vendorsLegitimateInterest[vendor.id];
};

export default isTCFVendorLegitimateInterestAccepted;
